import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  deleteNotification,
  getNotification,
  updateNotification,
} from '../../../../api/notification.api';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import {
  IGetNotification,
  INotificationRead,
} from '../../../../models/notification.model';
import Button from '../../../Button';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import ConfirmModal from '../../../modals/ConfirmModal';
import NoticeViewer from '../NoticeViewer';
import NoticeEditor2 from '../NoticeEditor2';
import _ from 'lodash';
import { RootState } from '../../../../store/rootReducer';
import { useSelector } from 'react-redux';
import { PERMISSIONS } from '../../../../constans';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  event: any;
  doGetClassNotice: () => void;
  // tutor dashboard에서 호출인지 여부
  isTutor?: boolean;
  // 학급명
  className?: string | undefined;
  noButton?: boolean;
}

const ShowNoticeModal2: FC<IProps> = ({
  visible,
  setVisible,
  event,
  doGetClassNotice,
  isTutor = false,
  className,
  noButton = false,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetNotification>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();

  const [isEdit, setIsEdit] = useState(false);
  const [toSubmit, setToSubmit] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [readCnt, setReadCnt] = useState<number>(0);
  const {auth} = useSelector((state: RootState) => state.auth);
  const [editAuth, setEditAuth] = useState(false);
  const [deleteAuth, setDeleteAuth] = useState(false);

  useEffect(() => {
    if (event) {
      execute(getNotification(event.id));
    }
  }, [event]);

  
  useEffect(() => {
    let _data: any = _.cloneDeep(res?.data?.notificationRead);
    let tempReadCnt = 0;
      
    if (_data?.length) {
      _data.forEach((item: INotificationRead, idx: number) => {
        if(item.readDateTime) {
          tempReadCnt++;
        }
      });
      setReadCnt(tempReadCnt);
    }

    if(res?.data) {
      if(PERMISSIONS.OPERATIONS_TEAM.includes(auth.groupNo)) {
        setEditAuth(true);
        setDeleteAuth(true);
      }
      
      if(res?.data?.writerMemberCode === auth.memberCode) {
        setEditAuth(true);

        const today = moment().format('YYYYMMDD');
        if(today == res?.data?.timetableDate || moment(today).isBefore(res?.data?.timetableDate)) {
          setDeleteAuth(true);
        }
      }
    }
  }, [res]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      doGetClassNotice();
      successNotification(t('common.message.edit1'));
      setVisible(false);
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      doGetClassNotice();
      successNotification(t('common.message.delete'));
      setConfirmDeleteVisible(false);
      setVisible(false);
    }
  }, [deleteRes, deleteIsLoading]);

  const submit = (data: FormData) => {
    if (!event) return;
    submitExecute(updateNotification(event.id, data));
  };

  const onDelete = () => {
    if (!event) return;
    deleteExecute(deleteNotification(event.id));
  };

  const columns: TableColumnsType<INotificationRead> = [
    {
      title: 'No',
      dataIndex: 'rowIdx',
      key: 'rowIdx',
      align: 'center',
      render: (value, record, idx)=>{return idx+1}
    },
    {
      title: t('class.class.column29'),
      dataIndex: 'studentMemberName',
      key: 'studentMemberName',
      align: 'center',
      sorter: (a, b) => a.studentMemberName?.localeCompare(b.studentMemberName),
    },
    {
      title: t('class.class.19'),
      dataIndex: 'checkYN',
      key: 'checkYN',
      align: 'center',
      render: (value, record) => (record.readDateTime ? 'Y' : 'N'),
      sorter: (a, b) => (a.readDateTime?'Y':'N')?.localeCompare(b.readDateTime?'Y':'N'),
    },
    {
      title: t('class.class.column96'),
      dataIndex: 'readDateTime',
      key: 'readDateTime',
      align: 'center',
      render: (value) =>
        value ? moment(value).format('YYYY.MM.DD HH:mm') : '-',
      sorter: (a, b) => (a.readDateTime===null?'9999-12-31':a.readDateTime)?.localeCompare(b.readDateTime===null?'9999-12-31':b.readDateTime),
    },
  ];

  return (
    <>
      {isLoading || submitIsLoading || deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={deleteError} />

      <Modal
        title={t('class.class.title15')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="cancel" className='btn-basic pink' onClick={() => setVisible(false)}>
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        {isEdit ? (
          <NoticeEditor2
            event={event}
            submit={submit}
            toSubmit={toSubmit}
            setToSubmit={setToSubmit}
            isTutor={isTutor}
            data={res?.data}
          />
        ) : (
          <NoticeViewer data={res?.data} className={className} />
        )}
        <div className="comm-bx__between">
          <div />
          {noButton ? null : isEdit ? (
            <div className="comm-btn__area">
              <Button
                onClick={() => setToSubmit(true)}
                className="btn-basic pink"
                text={t('common.button.save')}
              />
              <Button
                onClick={() => setVisible(false)}
                className="btn-basic gray-line ml-2"
                text={t('common.button.close')}
              />
            </div>
          ) : (
            <div className="comm-btn__area">
              {(editAuth) &&                 
                <Button
                  onClick={() => setIsEdit(true)}
                  className="btn-basic pink-line"
                  text={t('common.button.edit')}
                />
              }
              {(deleteAuth) &&
                <Button
                  onClick={() => setConfirmDeleteVisible(true)}
                  className="btn-basic gray ml-2"
                  text={t('common.button.delete')}
                />
              }
              <Button
                onClick={() => setVisible(false)}
                className="btn-basic gray-line ml-2"
                text={t('common.button.close')}
              />
            </div>
          )}
          <div />
        </div>
        <div>
          <div className="comm-bx__space">
            <div className='comm-sch_result'>
              {'※' + t('class.class.20') + ' : ' + readCnt + '명'}
            </div>
          </div>
          <div className='comm-table__area mt-0'>
            <Table
              columns={columns}
              dataSource={res?.data?.notificationRead}
              pagination={{
                pageSize: 9999999,
              }}
              rowClassName="pointer"
              rowKey="studentMemberCode"
            />
          </div>
        </div>
      </Modal>

      <ConfirmModal
        visible={confirmDeleteVisible}
        setVisible={setConfirmDeleteVisible}
        onConfirm={onDelete}
        titleText={t('system.menu.title6')}
        messageText={t('system.menu.text3')}
        confirmText={t('common.button.delete')}
        cancelText={t('common.button.cancel')}
      />
    </>
  );
};

export default ShowNoticeModal2;
